import styled from "styled-components";
import { colors, spacingExtender } from "ui-components";

const LayoutWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  flex-shrink: 0;
`;

const LayoutHeader = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${colors.whiteGrey};
  ${() => spacingExtender({ paddingV: "2", paddingH: "4" })};
`;

const LayoutBody = styled.div`
  width: 100%;
`;

export { LayoutWrapper, LayoutHeader, LayoutBody };



// WEBPACK FOOTER //
// ./src/common/styled/layout.js